module.exports = __webpack_public_path__ + "img/prev-arrow.7c2cceea.svg";